import React, { useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useEffect } from 'react';

function PurchaseAdviceModal({
    show,
    handleClose,
}) {
    const confirmBtnRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            confirmBtnRef?.current?.focus();
        }, 1);
    }, []);

    return (
        <Modal
            show={show}
            onHide={(e) => {
                handleClose && handleClose(e);
            }}
            centered
            className="timeline-confirmation-dialog"
            size="lg"
        >
            <Modal.Body>
                <div className="row">
                    <div className="col-12">
                        Purchase advice
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default PurchaseAdviceModal;
